module.exports = __webpack_public_path__ + "static/media/IoT-灯屏.613f9d85.jpg";